<template>
  <section id="confirm-page-section" class="section-scc-portal container">
    <div>
      <p class="p-confirm-page">You have successfully changed your mail and username.</p>
      <p class="p-confirm-page">
        To enter the portal you need to <router-link :to="{ name: 'loginDonor' } ">login</router-link>.
      </p>
    </div>
  </section>
</template>

<script>
import moment from "moment";
export default {
  name: "confirmPage",
  data() {
    return {
      dateDeath: null,
      oldMail: null,
      newMail: null,
      idDonor: null,
      action: null,
      dateActual: null,
    }
  },
  mounted() {
    this.dateActual = moment().format('YYYY-MM-DD hh:mm:ss');
    this.getData = this.$router.currentRoute.query
    this.actionChangeEmail();
  },
  methods: {
    async actionChangeEmail() {
      const dataChangeEmail = {
        apiPointAction: 'ProcessingChangeEmailLink',
        hashDateDeathLink: this.getData.hashDateDeathLink,
        hashMailNew: this.getData.hashMailNew,
        hashId: this.getData.hashId
      }

      this.$root.$emit("showSpinner");
      const res = await this.$store.dispatch('pages/SET_apiPointPortal', dataChangeEmail)
      this.$root.$emit("hideSpinner");
      if(res?.status == 'error' && res?.message == 'This link has expired') {
        this.dateDeathAlert()
      }
      if(res?.status == 'success') {
        console.log('Change Email -> success ');
        await this.$store.dispatch('auth/SET_logout', )
      }
    },
    dateDeathAlert(){
      this.$root.$emit('messageBox',
          {
            timeShow: 0,
            typeColor: "danger",
            textMessage: "This link has expired.",
          })
    }
  }
}
</script>

<style scoped>
.p-confirm-page{
  font-size: large
}
</style>
